module.exports = __webpack_public_path__ + "img/cover-login.5844d7fd.svg";